// Timeout for large file operations
export const FILE_OPERATION_TIMEOUT = 600000; // 10 minutes
